<template>
    <div>
        <div
            v-if="! notifications"
            class="columns is-multiline"
        >
            <SkeletonCard
                :count="4"
                :classes="classes"
            />
        </div>

        <Notification v-if="notifications && ! hasNotifications">
            No notifications found.
        </Notification>

        <div
            v-if="hasNotifications"
            class="columns is-multiline"
        >
            <Note
                v-for="note in notifications.Rows"
                :key="note.NotePK"
                :note="note"
                :class="classes"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification.vue';
import Note from './Note.vue';
import SkeletonCard from './SkeletonCard.vue';

export default {
    components: {
        Notification,
        Note,
        SkeletonCard,
    },

    props: {
        classes: {
            type: String,
            default: 'is-12',
        },
    },

    data: function() {
        return {
            page: 1,
            limit: 8,
        };
    },

    computed: {
        ...mapState('notes', [
            'notifications',
        ]),
        ...mapGetters('notes', [
            'hasNotifications',
        ]),
    },

    mounted() {
        this.getNotifications();
    },

    methods: {
        getNotifications() {
            this.$store.dispatch('notes/getNotifications', this.$data);
        },
    },
};
</script>
